import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "/images/logo.png";

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="datenschutz-page">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="Geile Kiste Logo" className="h-10 w-auto" />
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-gray-600 hover:text-[#3ECDC3] transition-colors"
            data-testid="back-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-8"
            
          >
            Datenschutzerklärung
          </h1>

          <div className="prose prose-gray max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">1. Datenschutz auf einen Blick</h2>
              
              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Allgemeine Hinweise</h3>
              <p className="text-gray-600 leading-relaxed">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Datenerfassung auf dieser Website</h3>
              <p className="text-gray-600 leading-relaxed">
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Wie erfassen wir Ihre Daten?</strong><br />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Wofür nutzen wir Ihre Daten?</strong><br />
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">2. Verantwortliche Stelle</h2>
              <p className="text-gray-600 leading-relaxed">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="text-gray-700 mt-4">
                Eugen Limon<br />
                geile Kiste - Fotobox Verleih<br />
                Hölzlestraße 27<br />
                78315 Radolfzell am Bodensee<br /><br />
                Telefon: +49 (0) 152 239 588 67<br />
                E-Mail: impressum@geile-kiste.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">3. Hosting</h2>
              <p className="text-gray-600 leading-relaxed">
                Wir hosten die Inhalte unserer Website bei Lima-City. Anbieter ist die TrafficPlex GmbH, Konsul-Smidt-Str. 90, 28217 Bremen, Deutschland. Details entnehmen Sie der Datenschutzerklärung von Lima-City: <a href="https://www.lima-city.de/datenschutz" target="_blank" rel="noopener noreferrer" className="text-[#3ECDC3] hover:underline">https://www.lima-city.de/datenschutz</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">4. Cookies</h2>
              <p className="text-gray-600 leading-relaxed">
                Unsere Internetseiten verwenden sogenannte „Cookies". Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Technisch notwendige Cookies:</strong><br />
                Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Seite erforderlich sind. Dazu gehört ein Cookie, das Ihre Cookie-Einstellungen speichert.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">5. Kontaktformular</h2>
              <p className="text-gray-600 leading-relaxed">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">6. Google reCAPTCHA</h2>
              <p className="text-gray-600 leading-relaxed">
                Wir nutzen „Google reCAPTCHA" (im Folgenden „reCAPTCHA") auf dieser Website. Anbieter ist die Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf dieser Website (z.B. in einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener Merkmale. Diese Analyse beginnt automatisch, sobald der Websitebesucher die Website betritt. Zur Analyse wertet reCAPTCHA verschiedene Informationen aus (z.B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder vom Nutzer getätigte Mausbewegungen).
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Die Nutzung von reCAPTCHA erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor missbräuchlicher automatisierter Ausspähung und vor SPAM zu schützen.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Weitere Informationen zu Google reCAPTCHA entnehmen Sie den Google-Datenschutzbestimmungen und den Google Nutzungsbedingungen unter folgenden Links:<br />
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#3ECDC3] hover:underline">https://policies.google.com/privacy</a><br />
                <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="text-[#3ECDC3] hover:underline">https://policies.google.com/terms</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">7. Ihre Rechte</h2>
              <p className="text-gray-600 leading-relaxed">
                Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
              </p>
              <ul className="list-disc list-inside text-gray-600 mt-4 space-y-2">
                <li><strong>Recht auf Auskunft</strong> (Art. 15 DSGVO)</li>
                <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
                <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
                <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
                <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
                <li><strong>Recht auf Widerspruch</strong> (Art. 21 DSGVO)</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Beschwerderecht bei der Aufsichtsbehörde:</strong><br />
                Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Die für uns zuständige Aufsichtsbehörde ist:<br /><br />
                Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg<br />
                Lautenschlagerstraße 20<br />
                70173 Stuttgart<br />
                <a href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank" rel="noopener noreferrer" className="text-[#3ECDC3] hover:underline">www.baden-wuerttemberg.datenschutz.de</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">8. SSL- bzw. TLS-Verschlüsselung</h2>
              <p className="text-gray-600 leading-relaxed">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">9. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p className="text-gray-600 leading-relaxed">
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand März 2026. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf dieser Website abgerufen werden.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-8 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} geile Kiste. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-gray-500 hover:text-[#3ECDC3] transition-colors text-sm">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-[#3ECDC3] font-medium text-sm">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
